import { client } from '../api/client'
import { ScheduleData } from '../types/scheduleTypes'
import { ptorequest, response } from '../types/shiftTypes'

const updateGiveupShift = (
  shiftid: number,
  entityid: number,
  essuserkey: number,
  storeId: number
): Promise<any> => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.put(
        `/Shift/GivUpShift?shifId=${shiftid}&entityId=${entityid}&essUserKey=${essuserkey}&storeId=${storeId}`
      )
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not get data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}
const getshifttimings = (date, id, entityId, storeId): Promise<any> => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.get(
        `Shift/GetMyShift?date=${date}&UserId=${id}&entityId=${entityId}&storeId=${storeId}`
      )

      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not get data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}
const getopenshifts = (
  obkey: number,
  startDate: string,
  endDate: string
): Promise<any> => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.get(
        `/Shift/GetOpenShifts?essUserKey=${obkey}&startDate=${startDate}&endDate=${endDate}`
      )
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not get data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}
const Pickup = (essuserkey: number, shiftid: number): Promise<response> => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.post(
        `/Shift/AcceptShift?essUserKey=${essuserkey}&shifId=${shiftid}`
      )
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not post data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}
const swapshift = (feed): Promise<response> => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.post(`/Shift/SwapTheShift`, feed)
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not post data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}
const postData = (data: ScheduleData) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.post(`/shift/PostDefaultSchedule`, data)
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'Could not post data' })
      }
      return null
    } catch (error) {
      reject(error)
    }
  })
}
const fetchswapshiftDetails = (shiftid: number): Promise<any> => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.get(
        `/Shift/GetShiftInfo?ShiftId=${shiftid}`
      )
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not get data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}

const fetchstatus = (essuserkey: number): Promise<any> => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.get(
        `Shift/DefaultScheduleStatus?essUserKey=${essuserkey}`
      )
      if (response.status === 200 || response.status === 400) {
        resolve(response.data)
      } else {
        reject({ message: 'could not get data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}

const submitPto = (data: ptorequest) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.post(`/shift/PTORequest`, data)
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'Could not post data' })
      }
      return null
    } catch (error) {
      reject(error)
    }
  })
}

const geteccodelist = (entityid: number) => {
  return new Promise(async (resolve, reject) => {
    try {
      const resposne = await client.get(
        `/OnBoarding/GetEcCodeList?entityId=${entityid}`
      )
      if (resposne.status === 200) {
        resolve(resposne.data)
      } else {
        reject({ message: 'Could not fetch data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}

const getPTOHistory = (
  entityId: number,
  essUserKey: number,
  storeId: number
) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.get(`/OnBoarding/GetAllPtoRequests`, {
        params: {
          EntityID: entityId,
          EssUserKey: essUserKey,
          StoreId: storeId
        }
      })
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'Could not fetch data' })
      }
    } catch (err) {
      reject(err)
    }
  })
}

const fetchWeekclockins = (
  startDate: string,
  endDate: String,
  userId: number,
  entityId: number,
  storeId: number
) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.get(
        `Shift/GetMyShift?StartDate=${startDate}&EndDate=${endDate}&UserId=${userId}&entityId=${entityId}&storeId=${storeId}`
      )
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not fetch data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}

const getLeaveBalances = (essUserKey: number): Promise<any> => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.get(
        `/Shift/GetLeaveBalances?essUserKey=${essUserKey}`
      )
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not fetch data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}

export const shiftService = {
  updateGiveupShift,
  getshifttimings,
  getopenshifts,
  Pickup,
  swapshift,
  postData,
  fetchstatus,
  fetchswapshiftDetails,
  submitPto,
  geteccodelist,
  getPTOHistory,
  fetchWeekclockins,
  getLeaveBalances
}

